import { formatDateForMySQL } from "components/formatDate";
import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const SendEstimate = async (estimateID,workReqID,navigate) => {
  const accesstoken = getToken();

  if (accesstoken) {
    try {        
      const response = await fetch(`${dev_baseUrl}/Invoice/sendEstimate?estimateID=${estimateID}&workReqID=${workReqID}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },        
      });
      
      const data = await response.json();                      
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else if(response.ok && !data.isError ){      
        return data;
      }       
    } catch (error) {
      console.error('Network error:', error);
      return { isError:true, message: 'An error occurred. Please try again later.' , error: error};
    }
  } else {
    console.warn('Access token is not available.');
    return { isError:true, message: 'An error occurred. Please try again later.'};
  }
};
